export enum RoleFitRanking {
  bestFit = 'bestFit',
  moderateFit = 'moderateFit',
  poorFit = 'poorFit',
}
